"use client";

import { DatePicker } from "@/components/ui/date-picker";
import {
  formatInstantByPattern,
  parseInstantByPattern,
  toDatetimeLocalValue,
} from "@/lib/datetime/display";
import {
  DEFAULT_DATE_FORMAT,
  tokenizeDateFormat,
} from "@/lib/datetime/pattern";

const SEGS = tokenizeDateFormat(DEFAULT_DATE_FORMAT);

type DatetimeInputProps = {

  value?: string | null;

  storage?: "iso" | "local";
  onValueChange?: (value: string | null) => void;
  className?: string;
  id?: string;
  disabled?: boolean;
};

function toDisplay(value: string | null | undefined): string {
  return formatInstantByPattern(value, SEGS);
}

function fromDisplay(display: string, storage: "iso" | "local"): string | null {
  const iso = parseInstantByPattern(display, SEGS);
  if (!iso) return null;
  return storage === "local" ? toDatetimeLocalValue(iso) : iso;
}

function DatetimeInput({
  value,
  storage = "iso",
  onValueChange,
  className,
  id,
  disabled,
}: DatetimeInputProps) {
  return (
    <DatePicker
      id={id}
      value={toDisplay(value)}
      format={DEFAULT_DATE_FORMAT}
      disabled={disabled}
      className={className}
      onChange={(next) => onValueChange?.(next ? fromDisplay(next, storage) : null)}
    />
  );
}

export { DatetimeInput };
export {
  parseDatetimeLocalValue,
  toDatetimeLocalValue,
  resolveDatetimeLocalStart,
  todayDatetimeLocalStart,
} from "@/lib/datetime/display";
